var render = function render(_c, _vm) {
  return _c(
    "section",
    {
      staticClass: "row roomy align-stretch margin-bottom-2xl",
      attrs: { id: "other" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
        },
        [
          _c(
            "site-link",
            {
              staticClass: "card roomy yellow",
              staticStyle: { height: "100%" },
              attrs: { to: { name: "license.pro" } },
            },
            [
              _c(
                "div",
                { staticClass: "header padding-y-4xl" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.parent.$v6.solid.faFileCertificate,
                      size: "3x",
                      "fixed-width": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section text-left size-sm" }, [
                _c("h3", { staticClass: "h4" }, [
                  _vm._v("Font Awesome Pro License"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "See how and where you can use Font Awesome Pro/Pro+'s icons and software in your projects and work."
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "column-12 tablet:column-6 laptop:column-4 margin-bottom-2xl laptop:margin-bottom-0",
        },
        [
          _c(
            "site-link",
            {
              staticClass: "card roomy teal",
              staticStyle: { height: "100%" },
              attrs: { to: { name: "license.free" } },
            },
            [
              _c(
                "div",
                { staticClass: "header padding-y-4xl" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.parent.$v6.solid.faSunrise,
                      size: "3x",
                      "fixed-width": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section text-left size-sm" }, [
                _c("h3", { staticClass: "h4" }, [
                  _vm._v("Font Awesome Free License"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Read the details on how you can use Font Awesome Free pretty much anywhere and everywhere."
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column-12 tablet:column-6 laptop:column-4" },
        [
          _c(
            "site-link",
            {
              staticClass: "card roomy blue",
              staticStyle: { height: "100%" },
              attrs: { to: { name: "tos" } },
            },
            [
              _c(
                "div",
                { staticClass: "header padding-y-4xl" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.parent.$v6.solid.faScaleBalanced,
                      size: "3x",
                      "fixed-width": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section text-left size-sm" }, [
                _c("h3", { staticClass: "h4" }, [_vm._v("Terms of Service")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Understand what terms and expectations we have of you when using Font Awesome's icons, software, and services."
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }